<!-- 示例页面 -->
<template>
  <div class="page">
    <div class="p16 flex-row">
      <div>
        <span class="cur" @click="back"><i class="el-icon-arrow-left"></i>返回</span>
        <el-divider direction="vertical"  class="color999"></el-divider>
        <span class="color999 cur" @click="back">库存管理&nbsp;/&nbsp;</span>
      </div>
      <div>产品出库</div>
    </div>
    <div class="page-head">
      <div class="mains-content">
        <div class="member-content-box br10">
          <div class="member-header space-between">
            <div>
              <el-date-picker v-model="query.dataMonth" type="month" value-format="yyyy-MM" placeholder="选择月" @change="totalCounts" :clearable="false"></el-date-picker>
              <el-select v-model="query.billCategoryId" placeholder="出库类型" filterable @change="selectChange" class="ml10">
                <el-option
                  v-for="item in option1"
                  :key="item.value"
                  :label="item.text"
                  :value="item.value">
                </el-option>
              </el-select>
              <el-select v-model="query.auditStatus" placeholder="全部状态" filterable @change="selectChange" class="ml10">
                <el-option
                  v-for="item in option2"
                  :key="item.value"
                  :label="item.text"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
            <el-button type="primary" @click="addList">新增出库</el-button>
          </div>
          <div class="plr16">
            <el-table :data="list" :max-height="height - 265" header-cell-class-name="table_header_bgcolor">
              <el-table-column prop="itemNames" label="产品" width="200px"></el-table-column>
              <el-table-column prop="billCategoryName" width="auto" label="出库类型"></el-table-column>
              <el-table-column prop="oxCtime" label="申请时间" width="170px">
                <template slot-scope="scope">{{ formatDate(scope.row.createTime) }}</template>
              </el-table-column>
              <el-table-column prop="createName" width="auto" label="制单人员"></el-table-column>
              <el-table-column prop="auditStatusCn" label="审核状态" width="auto"></el-table-column>
              <el-table-column prop="amt" label="操作" align="center" fixed="right" width="100">
                <template slot-scope="scope">
                    <el-link type="primary" @click="leaveRequest(scope.row)">详情</el-link>
                    <el-link type="primary" class="ml5" v-if="scope.row.isCanCancel" @click="cancelVacation(scope.row)">销假</el-link>
                    
                </template>
              </el-table-column>
            </el-table>
            <paging :currentPage="query.start" :totalCount="totalCount" @doPageQuery="doDataQuery"></paging>
          </div>
        </div>
      </div>
    </div>
    <edit-set ref="editSetForm" @change="handleChange"></edit-set>
    <add-set ref="addSetForm" @change="handleChange"></add-set>
    <cancel-vacation ref="cancelForm" @change="handleChange"></cancel-vacation>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import editSet from "./edit";
import addSet from "./add";
import cancelVacation from "./cancelVacation.vue"
export default {
  data() {
    return {
      url: this.$url.inventoryWastageInfo.list,
      query: {
        dataMonth: "",
        billCategoryId: "",
        auditStatus: "",
        start: 0,
        size: 20
      },
      height: this.$store.getters.MainHeight,
      option1: [
          {
            text: "出库类型",
            value: ""
          },
      ],
      option2: [{
            text: "全部状态",
            value: ""
          },
          {
            text: "待审核",
            value: "wait"
          },
          {
            text: "处理中",
            value: "processing"
          },
          {
            text: "通过",
            value: "pass"
          },
          {
            text: "拒绝",
            value: "refuse"
          },
          {
            text: "取消",
            value: "cancel"
          },
        ],
      list: []
    };
  },
  mixins: [minxin],
  components: { editSet, cancelVacation, addSet},
  computed: {},

  created() {
    this.query.dataMonth = this.formatMonth(new Date())
    this.getType();
    this.totalCounts();
  },

  methods: {
    back() {
      this.$router.push("/dataList/inventory");
    },
    leaveRequest (row) {
      this.$refs["editSetForm"].$emit("set", row);
    },
    addList () {
      this.$refs["addSetForm"].$emit("set", true);
    },
    getType() {
      this.$api.post(this.$url.inventoryWastageInfo.pullDownList,{systemTag:'no',billType:'wastage'}).then(res => {
        if (res) {
          let arr = [];
          res.map(item => {
            arr.push({text: item.name,value: item.id});
          })
          this.option1 = this.option1.concat(arr);
        }
      });
    },
    handleChange(bool) {
      if (bool) {
        this.totalCounts();
      }
    },
    selectChange() {
      this.query.start = 0;
      this.totalCounts();
    },
    totalCounts () {
      this.$api.post(this.$url.inventoryWastageInfo.count, this.query).then(res => {
        this.getData();
        this.totalCount = res;
      }).catch(error => {});
    },
    cancelVacation (row) {
      this.$refs["cancelForm"].$emit("set", row);
    }
  }
};
</script>
<style scoped lang="less">
@import "../../../assets/css/edit.less";
.page-head {
  height: 100%;
}
.mains-content {
  height: calc(100% - 72px);
  .member-content-box {
    background: #fff;
  }
  .member-header {
    
    padding: 16px;
    display: flex;
  }
}
</style>

